module.exports = __webpack_public_path__ + "img/qualityControl.77ecb3b.jpg";